import { authApi } from '@app/services';

/**
 * Инициализация просиходит в:
 * При первом заходе в приложение router/index.js
 * При логине views/test/Userbar.vue
 */
export default {
  namespaced: true,
  state: {
    userId: null,
    userName: null,
    userInitials: null,
    avatar: null,
    roles: [],
    permissions: null,
    resources: null,
    firstName: null,
    lastName: null,
    isSocial: null,
    is_superuser: false
  },
  mutations: {
    setUserId(state, id) {
      state.userId = id;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    setUserInitials(state, initials) {
      state.userInitials = initials;
    },
    setAvatar(state, avatar) {
      state.avatar = avatar;
    },
    setPermissions(state, payload) {
      state.permissions = payload;
    },
    setResources(state, payload) {
      state.resources = payload;
    },
    removeResources(state) {
      state.resources = null;
    },
    setRoles(state, payload) {
      state.roles = payload;
    },
    setFirstName(state, payload) {
      state.firstName = payload;
    },
    setLastName(state, payload) {
      state.lastName = payload;
    },
    setIsSocial(state, payload) {
      state.isSocial = payload;
    },
    setSuperuser(state, payload) {
      state.is_superuser = payload;
    }
  },
  actions: {
    async loadPermissions({ commit }) {
      const config = await authApi.getUserConfig();
      const { profile } = config;
      const initials = `${profile.first_name.charAt(
        0
      )}${profile.last_name.charAt(0)}`;
      //const avatar = profile.avatar ? profile.avatar[0] !== 'h' ? process.env.VUE_APP_API_URL + '/' + profile.avatar : profile.avatar : null;
      const avatar = profile.avatar;
      commit('setUserInitials', initials);
      commit('setUserName', `${profile.first_name} ${profile.last_name}`);
      commit('setLastName', profile.last_name);
      commit('setFirstName', profile.first_name);
      commit('setAvatar', avatar);
      commit('setUserId', config.id);
      commit('setResources', config.resources);
      commit('setPermissions', config.permissions);
      commit('setRoles', config.roles);
      commit('setIsSocial', config.is_social);
      commit('setSuperuser', config.is_superuser);
    }
  }
};
